export default __webpack_public_path__ + "static/media/charter_italic-webfont.ecf13767.eot";